export default __webpack_public_path__ + "static/media/files-setting.e5c55fa1.svg";